import { useState } from 'react';
import Ratio from 'react-bootstrap/Ratio';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import defaultImage from '../../assets/images/video-img.jpg';
import './video.scss';

function VideoPopup(props) {
  const [show, setShow] = useState(false);

  return (
    <>
      <div className={`video-popup ${props.theme || ''}`}>
        <Button
          className="video-btn"
          variant="primary"
          onClick={() => setShow(true)}
        >
          <i className="fas fa-play fa-1x"></i>
        </Button>
        {(props?.theme === 'video-style-2') === !props.imageHide || (
          <img
            alt="video-image"
            className="img-fluid image-link border-radius-7"
            src={props.videoImage || defaultImage}
          />
        )}
      </div>

      <Modal
        show={show}
        size={props.size || 'md'}
        onHide={() => setShow(false)}
        dialogClassName="pgs-video-popup"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Ratio aspectRatio="16x9">
            
          <iframe width="560" height="315" src="https://www.youtube.com/embed/SVH5a4A8LFI?si=T1315YgT0dxSN7HK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </Ratio>
        </Modal.Body>
      </Modal>
    </>
  );
}

function VideoPopup2(props) {
  const [show, setShow] = useState(false);

  return (
    <>
      <div className={`video-popup video-popup-style-02 ${props.theme || ''}`}>
        <Button
          className="video-btn"
          variant="primary"
          onClick={() => setShow(true)}
        >
          <i className="fas fa-play fa-1x"></i>
        </Button>
        <a href="#">See Our Video</a>
      </div>

      <Modal
        show={show}
        size={props.size || 'md'}
        onHide={() => setShow(false)}
        dialogClassName="pgs-video-popup"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Ratio aspectRatio="16x9">
            <video src={props.videoURL} controls autoPlay>
              </video>
          </Ratio>
        </Modal.Body>
      </Modal>
    </>
  );
}

function VideoPopup3(props) {
  const [show, setShow] = useState(false);

  return (
    <>
      <div className={`video-popup ${props.theme || ''}`}>
        <Button
          className="video-btn"
          variant="primary"
          onClick={() => setShow(true)}
        >
          <i className="fas fa-play fa-1x"></i>
        </Button>
        {(props?.theme === 'video-style-2') === !props.imageHide || (
          <img
            alt="video-image"
            className="img-fluid image-link border-radius-7"
            src={props.videoImage || defaultImage}
          />
        )}
      </div>

      <Modal
        show={show}
        size={props.size || 'md'}
        onHide={() => setShow(false)}
        dialogClassName="pgs-video-popup"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Ratio aspectRatio="16x9">
            
          <video src={props.videoURL} controls>
          </video>          
          </Ratio>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default VideoPopup;
export { VideoPopup2,VideoPopup3 };
